<template>
  <div id="app">
    <!-- 添加路由占位符: 指定路由规则匹配到的组件的渲染位置 -->
    <router-view></router-view>
  </div>
</template>
<script>
// 对外导出一个对象
export default {}
</script>
